import React, {Component} from "react";


class Table extends Component{
    constructor(props) {
        super(props);
        this.state = {
            settings: {"s": true, "p": true, "w": true, "m": false},
            pie_chart_color: {"possible": "rgba(2,132,199,1)", "sure": "#65a30d", "missing": "#ea8034", "wrong": "#dc2626"},
        }
    }

    activate = (c)=>{
        const {settings} = this.state
        let temp = settings
        temp[c] = !settings[c]
        this.setState({
         settings: temp
     })
    }

    render() {
        const {pairs} = this.props;
        const {settings, pie_chart_color} = this.state
        const default_cell_css = "text-center px-8 py-2 mr-1 text-neutral-600"
        const colors = {"s": "rgba(101,163,13,1)", "p": "rgba(2,132,199,1)",
            "w": "rgba(220,38,38,1)", "m": "rgba(234,128,52,1)"}
        return (
            <div className="block text-center">
                <div className="flex m-auto justify-center mb-3">
                    <button className="mr-2 text-xs text-white px-2 rounded py-1" onClick={()=>{this.activate("s")}}
                          style={{backgroundColor: settings["s"]?pie_chart_color["sure"]:"#CCCCCC"}}>
                    Sure</button>
                    <button className="mr-2 text-xs text-white px-2 rounded py-1" onClick={()=>{this.activate("p")}}
                            style={{backgroundColor: settings["p"]?pie_chart_color["possible"]:"#CCCCCC"}}>
                        Possible</button>
                    <button className="mr-2 text-xs text-white px-2 rounded py-1" onClick={()=>{this.activate("m")}}
                          style={{backgroundColor: settings["m"]?pie_chart_color["missing"]:"#CCCCCC"}}>
                                                    Missig</button>
                    <button className="mr-2 text-xs text-white px-2 rounded py-1" onClick={()=>{this.activate("w")}}
                          style={{backgroundColor: settings["w"]?pie_chart_color["wrong"]:"#CCCCCC"}}>
                                                    Wrong</button>
                </div>
                <div >
                    <table className="table-auto w-24  m-auto text-xs shadow-lg border rounded">
                        <thead className="block">
                        <tr className="border-b-2" >
                            <th className={default_cell_css}>Source</th>
                            <th className={default_cell_css}>Translation</th>
                        </tr>
                        </thead>
                        <tbody style={{height:330, overflowY: "auto", overflowX: "hidden",display:"block"}}>
                        {pairs.map((x, i)=>{
                            return(
                                settings[x.cls]?
                                <tr key={"tr_id_"+i} className="border-b-2 text-white font-semibold"
                                    style={{borderColor: colors[x.cls], color:  colors[x.cls]}}>
                                    <td className={default_cell_css} style={{color:  colors[x.cls]}}>{x.src}</td>
                                    <td className={default_cell_css} style={{color:  colors[x.cls]}}>{x.tgt}</td>
                                </tr>:null)
                        })}
                        </tbody>
                    </table>
                </div>

            </div>
        )
    }
}

export default Table;